import {EventoCalendarioType} from "../../../api-clients/generated/services";

export enum VisualizationCalendarModalEnum {
  PASTA_IN_BIANCO = 'PASTA IN BIANCO',
  ASSENZA_STUDENTE ='ASSENZA STUDENTE',
}

export interface CalendarioModificaOption {
  tipoEvento: EventoCalendarioType;
  giorni: Array<string>;
}
